import { render, staticRenderFns } from "./JcomMembersStatusUpdate.vue?vue&type=template&id=1b84a8da"
import script from "./JcomMembersStatusUpdate.vue?vue&type=script&lang=js"
export * from "./JcomMembersStatusUpdate.vue?vue&type=script&lang=js"
import style0 from "./JcomMembersStatusUpdate.vue?vue&type=style&index=0&id=1b84a8da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports